<div>
  <div class="container">
    <hr />
    <app-comunications></app-comunications>
  </div>
</div>